<div class="outer" [ngClass]="{'animateCellIn': triggerAnimation}">
  <div class="inner bg">
    <div class="content">
      <h1 class="title" #content>OUR TEAM</h1>
      <div class="frame">
        <app-team-member class="member" [member]="member" *ngFor="let member of team$ | async" (selected)="onSelected($event)" [ngClass]="{'animateIn': triggerAnimation}"></app-team-member>
      </div>

      <div *ngIf="showJoinBanner$ | async" class="join-banner-container">
        <a href="/apply" class="join-banner">{{joinBannerText$ | async}}</a>
      </div>
    </div>
  </div>
</div>